import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const loginUser = (payload) => {
  return Api(endPoints.userLogin, payload, requestType.POST);
};

const changPassward = (payload) => {
  return Api(endPoints.userChagePassward, payload, requestType.POST);
};

const otpCode = (payload) => {
  return Api(endPoints.userOTP, payload, requestType.POST);
};

const forgetPassword = (payload) => {
  return Api(endPoints.userForgetPassword, payload, requestType.POST);
};

const registerUser = (payload) => {
  return Api(endPoints.userSendCode, payload, requestType.POST);
};
const userOtp = (payload) => {
  return Api(endPoints.userOtp, payload, requestType.POST);
};
const userSendCode = (payload) => {
  return Api(endPoints.userSendCode, payload, requestType.POST);
};
const accountDelete = (id) => {
  return Api(`${endPoints.deleteAccount}/${id}`, {}, requestType.DELETE);
};

export {
  loginUser,
  registerUser,
  changPassward,
  otpCode,
  forgetPassword,
  userOtp,
  userSendCode,
  accountDelete,
};
